<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options">
      <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
        <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
      </div>
      <div
        v-if="props.row.date_ed_decompte"
        slot="date_ed_decompte"
        slot-scope="props"
        class="slot-date"
      >
        <span class="badge badge-success p-2">{{ formatDate(props.row.date_ed_decompte) }}</span>
      </div>
      <div v-if="props.row.date_em_pai" slot="date_em_pai" slot-scope="props" class="slot-date">
        <span class="badge badge-success p-2">{{ formatDate(props.row.date_em_pai) }}</span>
      </div>
      <span
        v-if="props.row.nom_ben_rglt"
        slot="nom_ben_rglt"
        slot-scope="props"
      >{{ props.row.nom_ben_rglt }}</span>
      <span
        v-if="props.row.nom_dest_decompte"
        slot="nom_dest_decompte"
        slot-scope="props"
      >{{ props.row.nom_dest_decompte }}</span>

      <div v-if="props.row.tot_payer && props.row.tot_payer < 0" slot="tot_payer" slot-scope="props" class="slot-number">
        <span style="font-weight:bold">{{ formatNumber(props.row.tot_payer) }}</span>
      </div>
      <div v-else slot="tot_payer" slot-scope="props" class="slot-number">
        <span>{{ formatNumber(props.row.tot_payer) }}</span>
      </div>
      <div
        v-if="props.row.id_pp_dest_reglement"
        slot="id_pp_dest_reglement"
        slot-scope="props"
        class="slot-number"
      >
        <span>{{ props.row.id_pp_dest_reglement }}</span>
      </div>
      <div
        v-if="props.row.nir_pp"
        slot="nir_pp"
        slot-scope="props"
        class="slot-number"
      >
        <span>{{ formatNir(props.row.nir_pp) }}</span>
      </div>


      <div v-if="props.row.num_decompte" slot="num_decompte" slot-scope="props" class="slot-number">
        <span>{{ props.row.num_decompte }}</span>
      </div>
      <div
        v-if="props.row.numero_contrat_col"
        slot="numero_contrat_col"
        slot-scope="props"
        class="slot-number"
      >
        <span>{{ props.row.numero_contrat_col }}</span><br><span class="family-prod">{{ props.row.produit }}</span>
      </div>
      <div v-if="props.row.lib_gar" slot="lib_gar" slot-scope="props">
        <span :class="'decompte-' + props.row.type_decompte">{{ props.row.lib_gar }}</span>
      </div>

      <!-- Pour la liste des décomptes après recherche -->
      <span
        v-if="props.row.nom_ben_presta"
        slot="nom_ben_presta"
        slot-scope="props"
      >{{ props.row.nom_ben_presta }} {{ props.row.prenom_ben_presta }}</span>
      <span
        v-else
        slot="nom_ben_presta"
        slot-scope="props"
      >{{ props.row.nom_dest }} {{ props.row.prenom_dest }}</span>
      <span
        v-if="props.row.nom_dest"
        slot="nom_dest"
        slot-scope="props"
      >{{ props.row.nom_dest }} {{ props.row.prenom_dest }}</span>
      <!-- Pour la liste des décomptes après recherche -->

      <div v-if="(props.row.type_decompte == 'dc' && props.row.tot_payer < 0 || props.row.tot_payer == 0 )" slot="decomptePdf" slot-scope="props">
      </div>
      <div v-else class="wrapper" slot="decomptePdf" slot-scope="props">
        <b-button
          type="button"
          @click="download(props.row.id, props.row.num_decompte, props.row.type_decompte, props.row.id_pp_dest_reglement)"
          class="badge badge-primary p-2"
        >
          <i class="fa fa-download" title="Télécharger"></i>
        </b-button>
      </div>
    </v-server-table>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "../utils/auth";

export default {
  name: "DecompteTable",
  props: ["tableEntry"],
  data() {
    let self = this;
    return {
      url: '',
      columns: [
        "created_at",
        "date_ed_decompte",
        "id_pp_dest_reglement",
        "nir_pp",
        "num_decompte",
        "numero_contrat_col",
        "nom_ben_presta",
        "nom_dest",
        "rs_pm_site",
        "lib_gar",
        "date_em_pai",
        "tot_payer",
        "decomptePdf"
      ],
      options: {
        headings: {
          created_at: "Date de chargement",
          date_ed_decompte: "Date d'édition",
          id_pp_dest_reglement: "N° Ident. NSI",
          nir_pp: "N° Sécu. Soc.",
          num_decompte: "N° Décompte",
          numero_contrat_col: "N° Contrat /\nFamille prod.",
          nom_ben_presta: "Bénéficiaire",
          nom_dest: "Destinataire",
          rs_pm_site: "Etablissement",
          lib_gar: "Type de rente",
          date_em_pai: "Date de paiement",
          tot_payer: "Montant",
          decomptePdf: "Décompte"
        },
        columnsClasses: {
          rs_pm_site: "smaller",
          tot_payer: "montant"
        },
        sortable: ["date_ed_decompte"],
        orderBy: { ascending:false },
        filterable: false,
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: { filterPlaceholder: "N°Identifiant NSI, N° décompte" },
        requestFunction: function (data) {
            // self.url = '/espaceBeneficiaire/decomptes/recherche_decomptes_bo'
            if (typeof self.tableEntry.benefId !== 'undefined' && self.tableEntry.benefId != '') {
              let benefId = self.tableEntry.benefId;
              self.url = '/espaceBeneficiaire/beneficiaires/decomptes/' + benefId
              data["benefId"] = self.tableEntry.benefId;
            }
            else {
              self.url = '/espaceBeneficiaire/decomptes/recherche_decomptes_bo'
              data["type_decompte"] = self.tableEntry.type_decompte;
              data["num_decompte"] = self.tableEntry.num_decompte;
              data["id_pp"] = self.tableEntry.id_pp;
              data["num_dossier"] = self.tableEntry.num_dossier;
              data["nir"] = self.tableEntry.nir;
              data["nom"] = self.tableEntry.nom;
              data["prenom"] = self.tableEntry.prenom;
              data["date_du"] = self.tableEntry.date_du;
              data["date_au"] = self.tableEntry.date_au;
              data["noSearch"] = self.$parent.noSearch
            }

            self.$store.commit("IS_LOADING", true);

            return axios.get(self.url, {
                params: data
            })
            .catch(function (e) {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 5000
              });
            }.bind(this));
        }
      }
    };
  },
  methods: {
    onLoaded(){
      if (typeof this.tableEntry.benefId !== 'undefined' && this.tableEntry.benefId != '') {
        this.$event.emit('getDecomptes')
      } else {
        this.$store.commit("IS_LOADING", false)
      }
    },
    downloadFile(response, numDecompte, category) {
      let newBlob = new Blob([response.data], { type: "application/pdf" });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      if (category == "decompte") {
        link.download = "decompte_" + numDecompte + ".pdf";
      } else {
        link.download = "attestation" + numDecompte + ".pdf";
      }
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.open(link, "_blank");
      setTimeout(function() {
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    formatNir(textNir) {
      if(textNir !== null  && textNir !== ''){

        let nirs = textNir.split(',');
        let displayNir = '';

        nirs.forEach(function (element){
          if(element.length > 13){
            if(displayNir === ''){
              displayNir = element.substring(0,13);
            }else{
              displayNir = displayNir + '\n' + element.substring(0,13);
            }
          }
        });
        return displayNir;
      }else{
        return textNir;
      }
    },
    download(decompteId, numDecompte, typeRente, idpp) {
      let self = this;
      let dataPost = {};
      dataPost.idpp = idpp;
      dataPost.typeRente = typeRente;
      dataPost.provider = getProvider();

      this.$store.commit("IS_LOADING", true);
      this.$axios
        .post(
          "/espaceBeneficiaire/beneficiaires/decomptes/download/" + decompteId,
          dataPost,
          { responseType: "arraybuffer" }
        )
        .then(response => {
          this.$event.emit('refreshBeneficiaire');
          this.$store.commit("IS_LOADING", false);
          this.downloadFile(response, numDecompte, "decompte");
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          let errorText =
            "Une erreur est survenue, veuillez réessayer. Si le problème persiste veuillez contacter chorum";
          if (
            error.response &&
            error.response.status === 403 &&
            self !== undefined
          ) {
            errorText = "Accès non autorisé.";
          }
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: errorText,
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
    formatDate(textDate) {
      return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
    }
  }
};
</script>

<style scoped>
.VueTables__search-field input {
  width: 240px !important;
}

#list-decomptes-table .wrapper {
  text-align: center;
}
</style>
